import { Injectable } from "@angular/core";
import { set as _set } from "lodash";
import { BehaviorSubject ,  Subscription } from "rxjs";
import { NSFormFields } from "../../../../types";
import { FieldStateService } from "../../field-state.service";

@Injectable()
export class RadioGroupStateService extends FieldStateService {
    public stateObservable$: BehaviorSubject<any>;
    public stateSubscriber$: Subscription;

    constructor() {
        super();
    }

    public dispatchFieldUpdate(payload, index?): void {
        const newState = super.newState({});
        index = index || this.fieldOptions.findIndex((row) => row.value === payload);
        _set(newState, ["options", index, "state"], payload);
        _set(newState, ["value"], payload);
        this.stateObservable$.next(newState);
    }

    public dispatchFieldLoad(payload): void {
        const selectedOptionIndex = this.fieldOptions.findIndex((opt) => opt.value === payload);
        const options = [...this.fieldOptions];
        const option = options[selectedOptionIndex];
        if (!!option) { option.state = payload; }
        this.stateObservable$.next(super.newState({ options, value: payload }));
    }

    public dispatchListLoad(payload): void {
        const options = payload.map((option) => {
            return { label: option.name, value: option.id, state: undefined };
        });
        this.stateObservable$.next(super.newState({ options }));
    }

    public get fieldOptions(): NSFormFields.IOptionsState[] {
        return this.stateObservable$.getValue().options;
    }
}
